import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button, useHapticFeedback } from '@blade/ui-kit'
import { type CurrencyModel } from '@root/entities/currency'
import { useTranslation } from '@root/shared/localization'

import type { PremiumMetaModel } from '../../atoms'
import type { CurrencyWithPremium } from '@root/entities/currency'

type Props = {
  currency: CurrencyModel
  premium: PremiumMetaModel
  onExtend?: (currency: CurrencyWithPremium.CurrencyWithPremium) => void
  onActiveClick: () => void
}

export const ActivePremiumCardRenew: React.FC<Props> = ({
  currency,
  premium,
  onExtend,
  onActiveClick,
}) => {
  const haptics = useHapticFeedback()
  const { t } = useTranslation()
  const [allowedToExtend] = useAtom(premium.isAllowedToExtend)

  const handleClick = () => {
    haptics.impactOccurred('light')

    if (allowedToExtend) {
      onExtend?.({ currency, premium })
    } else {
      onActiveClick()
    }
  }

  return (
    <Root
      variant="soft"
      size="xs"
      radius="rounded"
      aria-disabled={!allowedToExtend}
      onClick={handleClick}
    >
      {t('premium.button.renew-premium')}
    </Root>
  )
}

const Root = styled(Button)`
  color: var(--amber-9);

  font-size: var(--typography-description-semi-bold-font-size);
  line-height: var(--typography-description-semi-bold-line-height);
  font-weight: var(--typography-description-semi-bold-font-weight);
  padding-inline: 15px;
  padding-block: 8px;

  &[aria-disabled='true'] {
    background-color: var(--backgroundA-4);
    color: var(--textA-7);

    &:hover {
      background-color: var(--backgroundA-6);
    }
  }
`
